import {
  IForgotPasswordMailModel,
  IForgotPasswordModel,
  ITokenResponse,
  IUser,
} from "../models/User";
import $api, { API_URL } from "../http";
import axios from "axios";
import { getRefreshToken } from "../helper/auth";

class AuthServiceClass {
  // export const register = async (model: IRegisterModel) => {
  //     return $api.post<{message: string}>("api/otp-token/email", model);
  // }

  async login(model: { email: string; password: string }) {
    const response = await $api.post<ITokenResponse>("api/auth/login-admin", model);
    localStorage.setItem("access_token", response.data.accessToken);
    localStorage.setItem("refresh_token", response.data.refreshToken);
    return response;
  }

  async refreshToken() {
    return await axios.post<ITokenResponse>(`${API_URL}/api/auth/refresh-token`, {
      token: getRefreshToken(),
    });
  }

  async getCurrentUser() {
    try {
      return await $api.get<{ user: IUser; roles: string[] }>("api/auth/current-user-admin");
    } catch (e) {}
  }

  logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }

  // export const verifyOtpToken = async (token: string) => {
  //     return await $api.get<{status: string}>(`api/otp-token/verify/${token}`);
  // }
  //
  async forgotPassword(token: string, model: IForgotPasswordModel) {
    return await $api.put<any>(`api/users/forgot-password/${token}`, model);
  }

  // export const getUserByEmail = async (email: string)=> {
  //     return await $api.get<IUser>(`api/users/by-email/${email}`);
  // }
  //
  async sendForgotPasswordMail(model: IForgotPasswordMailModel) {
    return await $api.post<any>("api/otp-token/forgot-password-admin", model);
  }
}

export const AuthService = new AuthServiceClass();
